import React from 'react'
import EContent from 'src/modules/EContent'

const EContentPage = () => {
  return <EContent />
}

export default EContentPage
